module.exports = __webpack_public_path__ + "img/events-1.9c3980a9.jpg";